export const typography = {
    bodyFontSize: "1rem",
    inputFontSize: "1rem",
    fontFamily:
        'Lato, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji"',
    h1: {
        fontSize: "32px",
        fontWeight: 200,
        lineHeight: 1,
        letterSpacing: "-0.00833em",
        marginBottom: "24px",
    },
    h2: {
        fontSize: "32px",
        fontWeight: 400,
        lineHeight: 1,
        letterSpacing: "-0.00833em",
    },
    h3: {
        fontSize: "22px",
        fontWeight: 400,
        lineHeight: 1,
        marginTop: "20px",
        marginBottom: "10px",
    },
    h4: {
        fontSize: "18px",
        fontWeight: 400,
        lineHeight: 1,
        letterSpacing: "0.00735em",
    },
    h5: {
        fontSize: "16px",
        fontWeight: 400,
        lineHeight: 1,
        letterSpacing: "normal" as const,
    },
    h6: {
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: 1,
        letterSpacing: "0.0125em",
    },
    subtitle1: {
        fontSize: "1rem",
        fontWeight: 400,
        lineHeight: "1.75rem",
        letterSpacing: "0.00937em",
    },
    subtitle2: {
        fontSize: "0.875rem",
        fontWeight: 500,
        lineHeight: "1.375rem",
        letterSpacing: "0.00714em",
    },
    body1: {
        fontSize: "1rem",
        fontWeight: 400,
        lineHeight: "1.5rem",
    },
    body2: {
        fontSize: "0.875rem",
        fontWeight: 400,
        lineHeight: "1.25rem",
        letterSpacing: "0.01786em",
    },
    overline: {
        fontSize: "0.75rem",
        fontWeight: 500,
        lineHeight: "2rem",
        letterSpacing: "0.16667em",
    },
    caption: {
        fontSize: "0.75rem",
        fontWeight: 400,
        lineHeight: "1.25rem",
        letterSpacing: "0.03333em",
    },
    button: {
        textTransform: "none" as const,
        fontWeight: 400,
        borderRadius: 999,
    },
    genericBorderRadius: 8,
};

export default typography;
